import { useContext } from 'react'
import Card from '../../ui/Card'
import ReportOfProposedDebtService from '../../../services/ReportOfProposedDebtService';
import swal from 'sweetalert';
import { UserContext } from '../../../UseContext'
import { toast } from 'react-toastify'
import PrintPdfComponent from '../printPdfComponent'
import { renderToString } from 'react-dom/server'
import CommonService from '../../../services/CommonService';

const ProposedDebtReview = (props) => {
    const {issueId, proposedDebtDetails, proposeDebtDependencies, updateProposedDebtDetails} = props;
    const loginUserId = useContext(UserContext)

    async function checkFinancingParticipants() {
        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "checkProposeDebtFinancingParticipants",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "proposeDebtId": issueId,
                "filingDate" : proposedDebtDetails.filingDate
            }
        };
        await ReportOfProposedDebtService.checkFinancingParticipants(obj)
        .then((res) => res)
        .then((result) => {
            if (result.data.errors && result.data.errors.length > 0){
                toast(result.data.errors[0].message)
            }
            else{
                if(result.data.responses[0] && result.data.responses[0].length > 0) {
                    let alertMessage = "";
                   (result.data.responses).forEach((msg, i) => {
                    alertMessage +=  "- " + msg + "\n";
                    });
                    alert(alertMessage); 
                } else {
                    checkIfMarksRoosReportable(showPreSubmitAlert);
                }
            }
        })
    }
    const validateRequiredFields = async() => {
        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "getValidationMessagesProposeDebt",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "proposeDebtId": issueId
            }
        };
        ReportOfProposedDebtService.getValidationMessages(obj)
        .then((res) => res)
        .then((result) => {
            if (result.data.errors && result.data.errors.length > 0){
                alert(result.data.errors[0].message)
            }
            else{
                if(result.data.responses[0].length > 0) {
                  let alertMessage = "";
                  result.data.responses[0].forEach(item => {
                    alertMessage +=  "- " + item.message + "\n";
                  });
                  alert(alertMessage);
                } else {
                    checkFinancingParticipants();
                    //checkIfMarksRoosReportable(showPreSubmitAlert);            
                }
            }

        });
    }
    const validateProposedDebt =  () => {
        props.toggleWidget('review');
        validateRequiredFields();
    }

    const finalProposeDebt = async() => {
        const html = renderToString(<PrintPdfComponent proposedDebtDetails={proposedDebtDetails} proposeDebtDependencies={proposeDebtDependencies} />)

        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "finalProposedDebt",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "proposeDebtId": issueId,
                "user": CommonService.getUserName(loginUserId),
                "env" : "E",
                "html": html,
                "reportType" : "RPD"
            }
        };
    
       await ReportOfProposedDebtService.finalProposeDebt(obj)
        .then((res) => res)
        .then((result) => {
            if (result.data.errors && result.data.errors.length > 0){
                alert(result.data.errors[0].message)
            }
            else{
                if(result.data && result.data.responses[0]) {
                    updateProposedDebtDetails(result.data.responses[0].proposedDebtDetails);
                    var base64EncodedPDF = result.data.responses[0].pdf;
                    var arrrayBuffer = CommonService.base64ToArrayBuffer(base64EncodedPDF); 
                    var blob = new Blob([arrrayBuffer], {type: "application/pdf"});
                    var url = window.URL.createObjectURL(blob);
                    window.open(url);
                }
                toast.success("Report of Proposed Debt form has been successfully validated and submitted!");
            }

        });
    }
    const showPreSubmitAlert = () => {
        swal("Any issue of debt for which a report of final sale is submitted after January 21, 2017 will require the Issuer to submit an Annual Debt Transparency Report (ADTR) consisting of the information outlined in GOV 8855(k).", {
            buttons: [false, true],
        }).then(() => {
           finalProposeDebt();
        });
    }

    const checkIfMarksRoosReportable = async() => {
        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "IsProposeDebtMarksRoosReportable",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "proposeDebtId": issueId,
            }
        };
    
       await ReportOfProposedDebtService.checkIfMarksRoosReportable(obj)
        .then((res) => res)
        .then((result) => {
            if (result.data.errors && result.data.errors.length > 0){
                alert(result.data.errors[0].message)
            }
            else{
                if(result.data.responses[0]) {
                    swal("This debt issue may be reportable pursuant to GOV 6599.1 of the Marks-Roos Local Bond Pooling Act if the proceeds of the debt are used to acquire local obligations or transferred to a local obligor under the terms of a debt contract. (CDIAC Regulations, Section 6051).")
                    .then(() => {
                        showPreSubmitAlert();
                      });
                } else {
                    showPreSubmitAlert();
                }

            }

        });
    }

    return (
        <Card>
            <PrintPdfComponent proposedDebtDetails={proposedDebtDetails} proposeDebtDependencies={proposeDebtDependencies} /> 
            <div className="form">
                <div className="btn-div">
                    {/* <button className="custom-button" type="button" onClick={()=>props.openWidget('uploadDoc')}>Back</button> */}
                    <button className="fright custom-button" type="button" onClick={()=>validateProposedDebt()}>Validate & Submit</button>
                </div>
            </div>
        </Card>
    )
}

export default ProposedDebtReview
